import { defineMessages } from 'react-intl';

export default defineMessages({
    contactCallCenter: {
        id: 'adac.call-center-page.Contact Call Center',
        defaultMessage: 'Contact Call Center'
    },
    unableToProcess: {
        id: 'adac.call-center-page.We are unable to process your request online',
        defaultMessage: 'We are unable to process your request online'
    },
    pleaseCall: {
        id: 'adac.call-center-page.Please call our call center to continue using below phone number',
        defaultMessage: 'Please call our call center to continue using below phone number {phoneNumber}'
    },
    phoneNumber: {
        id: 'adac.call-center-page.+49 89 767676',
        defaultMessage: '+49 89 767676'
    },
    backButton: {
        id: 'adac.call-center-page.Back',
        defaultMessage: 'Back'
    }
});
